import { UserPermission } from '@/modules/permission/enum';
export const reportRoutes = [
    {
        path: 'taskReports',
        name: 'TaskReports',
        exact: true,
        component: () => import('../views/TaskReports.vue'),
        meta: {
            breadcrumb: [{ parent: 'Reports', label: 'Task Reports' }],
            permissions: [UserPermission.READ_TASK_DYNAMIC_REPORT],
        },
    },
    {
        path: 'debriefReports',
        name: 'DebriefReports',
        exact: true,
        component: () => import('../views/DebriefReports.vue'),
        meta: {
            breadcrumb: [{ parent: 'Reports', label: 'Debrief Reports' }],
            permissions: [UserPermission.READ_DEBRIEF_DYNAMIC_REPORT],
        },
    },
];
